<div class="container-right-main fluid-container">
  <h1>System Prompts</h1>
  <div *ngIf="isLoading" class="load">Loading tabs…</div>
  <div *ngIf="!isLoading && errorMessage" class="error">
    {{ errorMessage }}
  </div>
  <div *ngIf="!isLoading && isNoData && !errorMessage" class="no-data">
    No data available.
  </div>
  <mat-tab-group>
    <mat-tab *ngFor="let tab of tabs" [label]="tab.tabLabel">
      <div class="tab-content">
        <div class="row">
          <form [formGroup]="versionForm" class="form-section">
            <div class="updatedDiv">
              <label class="update-by">UPDATED DATE</label>
              <span class="UpDate">{{(tab.updated_date | date: 'MM-dd-yyyy hh:mm a') || 'N/A'}}</span>
            </div>
            <div class="updatedDiv1">
              <label class="update-by">UPDATED BY</label>
              <span class="UpBy">{{tab.updated_by || 'N/A'}}</span>
            </div>
            <div class="versionDiv">
              <label class="lbl-category">CHOOSE VERSION TO VIEW</label>
              <mat-form-field class="mb-cat cust-select">
                <mat-select formControlName="versionDrop" (selectionChange)="changeVersion($event, tab)"
                  placeholder="Choose Version">
                  <mat-option *ngFor="let Version of tab.version_list" [value]="Version.version+'_'+Version.id">
                    {{ Version.version }}<ng-container *ngIf="Version.created_date || Version.updated_date"> ({{ (Version.created_date || Version.updated_date) | date:'dd-MM-yyyy hh:mm a' }})</ng-container>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </form>
          <div class="button-wrapper editrestbtn">
            <button mat-button (click)="enableEditing(tab)" *ngIf="!tab.isEditing">Edit</button>
            <button mat-button (click)="onReset(tab)" *ngIf="!tab.isEditing">Reset Prompt</button>
          </div>
          <div *ngIf="tab.isEditing" class="button-wrapper cancelsubmitbtn">
            <button mat-button (click)="cancelEditing(tab)">Cancel</button>
            <button mat-button (click)="submitEditing(tab)">Save</button>
          </div>
        </div>
        <div class="mt-3">
          <mat-form-field appearance="fill" *ngIf="tab.isEditing">
            <textarea *ngIf="tab.isEditing" matInput [(ngModel)]="tab.content" id="textarea-{{tab.label}}"
              (input)="resizeTextarea($event.target)"></textarea>
          </mat-form-field>
        </div>
        <p *ngIf="!tab.isEditing" class="tabcont" [innerHTML]="tab.content"></p>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>